interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "FJD";
};

const FJD: Currency = Object.freeze({
  "displayName": "Fiji Dollar",
  "numericCode": 242,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "FJD",
  "symbol": "$"
});

export { FJD };
